if (!customElements.get('ctr-variants-dropdown')) {
  customElements.define(
    'ctr-variants-dropdown',
    class CtrVariantsDropdown extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.ctr-variants-dropdown__trigger');
        this.panel = this.querySelector('.ctr-variants-dropdown__panel');
        this.options = [];

        if (!this.trigger || !this.panel) return;

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);

        this.trigger.addEventListener('click', this.onTriggerClick);
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('focusout', this.onFocusOut);
      }

      connectedCallback() {
        this.refreshOptions();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      refreshOptions() {
        this.options = Array.from(this.panel.querySelectorAll('[role="option"]'));
      }

      get isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this.refreshOptions();
        this.panel.removeAttribute('hidden');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this.onDocumentClick);
      }

      close({ returnFocus = false } = {}) {
        this.panel.setAttribute('hidden', '');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);

        if (returnFocus) {
          this.trigger.focus();
        }
      }

      onTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.close();
        }
      }

      onFocusOut(event) {
        if (!this.isOpen) return;

        const nextTarget = event.relatedTarget;
        if (nextTarget && this.contains(nextTarget)) return;

        this.close();
      }

      onKeyDown(event) {
        if (!this.isOpen && event.target !== this.trigger) return;

        const focusableOptions = this.options.filter((option) => option.matches('a[href]'));
        const focusedIndex = focusableOptions.findIndex((option) => option === document.activeElement);

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (!this.isOpen) return;
            event.preventDefault();
            this.close({ returnFocus: true });
            break;
          case 'ARROWDOWN':
            if (!this.isOpen) return;
            event.preventDefault();
            this.focusOption(focusableOptions, focusedIndex + 1);
            break;
          case 'ARROWUP':
            if (!this.isOpen) return;
            event.preventDefault();
            this.focusOption(focusableOptions, focusedIndex - 1);
            break;
          case 'ENTER':
          case 'SPACE':
            if (event.target !== this.trigger) return;
            event.preventDefault();
            if (this.isOpen) {
              this.close();
            } else {
              this.open();
            }
            break;
          default:
            break;
        }
      }

      focusOption(options, index) {
        if (!options.length) return;

        const normalizedIndex = ((index % options.length) + options.length) % options.length;
        options[normalizedIndex].focus();
      }
    }
  );
}
